import { Icon } from "@circle-react-shared/Icon";
import { ComboboxButton } from "@headlessui/react-v2";
import classNames from "classnames";
import { forwardRef } from "react";

export interface ClearButtonProps {
  className?: string;
  onClick?: () => void;
}

export const ClearButton = forwardRef<HTMLButtonElement, ClearButtonProps>(
  ({ className, onClick }, ref) => (
    <ComboboxButton
      ref={ref}
      className={classNames(
        "text-dark absolute inset-y-0 right-0 flex items-center pr-4 disabled:!cursor-not-allowed disabled:!opacity-40",
        className,
      )}
      onClick={onClick}
    >
      <Icon type="20-cross" size={20} className="!h-4 !w-4" />
    </ComboboxButton>
  ),
);

ClearButton.displayName = "ClearButton";
